import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43b63381"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-section meter-readings" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { width: "15%" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { width: "15%" }, "Supplier"),
    /*#__PURE__*/_createElementVNode("th", { width: "15%" }, "Reference"),
    /*#__PURE__*/_createElementVNode("th", { width: "15%" }, "Location"),
    /*#__PURE__*/_createElementVNode("th", { width: "15%" }, "Readings"),
    /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Reason for non-inspection"),
    /*#__PURE__*/_createElementVNode("th", { width: "5%" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Actions")
    ])
  ])
], -1))
const _hoisted_4 = ["onMousedown"]
const _hoisted_5 = ["onUpdate:modelValue", "onChange"]
const _hoisted_6 = ["onUpdate:modelValue", "onChange"]
const _hoisted_7 = ["onUpdate:modelValue", "onChange"]
const _hoisted_8 = ["value", "onChange", "onKeyup"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_11 = { class: "input-group input-group-sm" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "Reason")
], -1))
const _hoisted_13 = ["onUpdate:modelValue", "onChange"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))

import { computed, inject, ref } from 'vue';
import { Report, Meter } from "@/models";
import Photos from "@/components/photo/Photos.vue";
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'Meters',
  setup(__props) {

const store = useStore();
const report = computed((): Report => store.getters['reports/current']);
const actProperty: any = inject('actProperty');

const setReportDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('reports/setReportDeep', payload);
};
const meterOptions = ref(["Electric", "Gas", "Heat", "Water", "Hot Water"]);

const meters = computed({
  get: () => report.value.meters,
  set: (data) => setReportDeep({ path: "meters", data })
});

const addNewMeter = () => {
  meters.value = meters.value.concat([new Meter()]);
};

const removeMeter = (index: number) => {
  actProperty
      .confirmPrompt()
      .then(
        () =>
          (meters.value = actProperty.removeItemByIndex(
            meters.value,
            index
          ))
      );
};

const addReading = (meterIndex: number) => {
  const updatedReadings = meters.value[meterIndex].readings.concat(['']);
  setReportDeep({ path: `meters[${meterIndex}].readings`, data: updatedReadings });
};

const setReading = ($event: any, meterIndex: number, readingIndex: number) => {
  setReportDeep({
    path: `meters[${meterIndex}].readings[${readingIndex}]`,
    data: $event.target.value,
  });
};

const removeReadingIfEmpty = ($event: any, meterIndex: number, readingIndex: number) => {
  let readings = meters.value[meterIndex].readings;
  if ($event.target.value === '' && readings.length > 1) {
    readings.splice(readingIndex, 1);
    setReportDeep({ path: `meters[${meterIndex}].readings`, data: readings });
  }
};

const onTagMeter = (val: string, index: number) => {
  if (index >= 0) {
    setReportDeep({ path: `meters[${index}].name`, data: val });
  }
};

const clearMeterName = (index: number) => {
  if (index >= 0) {
    setReportDeep({ path: `meters[${index}].name`, data: '' });
  }
};
const editMeter = (meter:Meter,index:Number) => {
 setReportDeep({
    path: `meters[${index}]`,
    data:meter
  });
}

return (_ctx: any,_cache: any) => {
  const _component_multiselect_text = _resolveComponent("multiselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meters.value, (meter, $index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: meter._uuid
          }, [
            _createElementVNode("td", null, [
              _createVNode(_component_multiselect_text, {
                modelValue: meter.name,
                "onUpdate:modelValue": ($event: any) => ((meter.name) = $event),
                options: meterOptions.value,
                "allow-empty": true,
                taggable: true,
                id: $index,
                onTag: onTagMeter,
                onSelect: ($event: any) => (editMeter(meter,$index))
              }, _createSlots({ _: 2 }, [
                (meter.name)
                  ? {
                      name: "clear",
                      fn: _withCtx(() => [
                        _createElementVNode("i", {
                          onMousedown: _withModifiers(($event: any) => (clearMeterName($index)), ["prevent","stop"]),
                          class: "multiselect__clear fa fa-times",
                          "aria-label": "Clear Meter"
                        }, null, 40, _hoisted_4)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["modelValue", "onUpdate:modelValue", "options", "id", "onSelect"]),
              _createElementVNode("div", null, [
                (_openBlock(), _createBlock(Photos, {
                  key: `meter${meter._uuid}in${meter.photos.length}`,
                  photos: meter.photos,
                  path: `meters[${$index}].photos`
                }, null, 8, ["photos", "path"]))
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control form-control-sm",
                "onUpdate:modelValue": ($event: any) => ((meter.supplier) = $event),
                onChange: ($event: any) => (editMeter(meter,$index))
              }, null, 40, _hoisted_5), [
                [
                  _vModelText,
                  meter.supplier,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control form-control-sm",
                "onUpdate:modelValue": ($event: any) => ((meter.reference) = $event),
                onChange: ($event: any) => (editMeter(meter,$index))
              }, null, 40, _hoisted_6), [
                [
                  _vModelText,
                  meter.reference,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control form-control-sm",
                "onUpdate:modelValue": ($event: any) => ((meter.location) = $event),
                onChange: ($event: any) => (editMeter(meter,$index))
              }, null, 40, _hoisted_7), [
                [
                  _vModelText,
                  meter.location,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("td", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meter.readings, (reading, $readingIndex) => {
                return (_openBlock(), _createElementBlock("input", {
                  key: $readingIndex,
                  class: "form-control form-control-sm",
                  value: reading,
                  onChange: ($event: any) => (setReading($event, $index, $readingIndex)),
                  onKeyup: _withKeys(($event: any) => (
                removeReadingIfEmpty($event, $index, $readingIndex)
              ), ["delete"])
                }, null, 40, _hoisted_8))
              }), 128)),
              _createElementVNode("button", {
                class: "btn btn-sm btn-primary mt-2",
                onClick: ($event: any) => (addReading($index))
              }, [
                _hoisted_10,
                _createTextVNode(" Reading ")
              ], 8, _hoisted_9)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": ($event: any) => ((meter.reason) = $event),
                  onChange: ($event: any) => (editMeter(meter,$index))
                }, null, 40, _hoisted_13), [
                  [
                    _vModelText,
                    meter.reason,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-danger",
                onClick: ($event: any) => (removeMeter($index)),
                tabindex: "-1"
              }, _hoisted_16, 8, _hoisted_14)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("button", {
      class: "btn btn-primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addNewMeter()))
    }, [
      _hoisted_17,
      _createTextVNode(" Meter ")
    ])
  ]))
}
}

})